import { Component, ViewChild } from '@angular/core';
import { CardlinkComponent } from '../cardlink/cardlink.component';

@Component({
  selector: 'app-alphabank',
  templateUrl: './alphabank.component.html',
  styleUrls: ['./alphabank.component.scss'],
})
export class AlphabankComponent {
  @ViewChild('cardlinkComponent') cardlinkComponent: CardlinkComponent;
  requestJSON: any;

  submitForm(requestJSON: any) {
    this.requestJSON = requestJSON;
    if (this.cardlinkComponent) {
      this.cardlinkComponent.submitForm(requestJSON);
    }
  }
}
